import React from 'react';
import { createPortal } from 'react-dom';

// Hard-block modal for a driver double-booking (CU-86cbbr6q8). Unlike the soft
// time-proximity ConflictWarning (which offers "Continue Anyway"), a window
// overlap is a physical impossibility — the driver is in two places at once — so
// the backend refuses it and this modal only explains and dismisses; there is no
// override. It is driven by the server's 422, so the message it shows is the
// backend's own, and the two can never disagree.
const OverlapBlockedModal = ({ driver, message, onClose }) => {
  const driverName = driver
    ? `${driver.username ?? driver.name ?? ''} ${driver.usersurname ?? driver.surname ?? ''}`.trim()
    : '';

  return createPortal(
    <>
      {/* Pure visual scrim — dismissal is via the X and OK buttons below, which
          are real, keyboard-accessible <button>s (no static-element click handler). */}
      <div style={{ zIndex: 10001 }} className="fixed inset-0 bg-black opacity-50" aria-hidden="true" />
      <div style={{ zIndex: 10002 }} className="fixed inset-0 flex items-center justify-center p-4 pointer-events-none">
        <div className="bg-white rounded-xl shadow-lg p-6 max-w-md pointer-events-auto border-2 border-black" style={{ position: 'relative' }}>
          <button
            className="text-gray-700 hover:text-gray-900 bg-gray-200 hover:bg-gray-300 rounded-full w-6 h-6 flex items-center justify-center"
            style={{ position: 'absolute', top: '0.5rem', right: '0.5rem', zIndex: 10 }}
            onClick={onClose}
            aria-label="Close"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          <h2 className="text-xl text-purple-500 font-semibold mb-4">Overlapping trip — not assigned</h2>
          <p className="mb-2 text-gray-700">
            {driverName ? <strong>{driverName}</strong> : 'This driver'} already has another trip that day whose time overlaps this one, so the assignment was not made.
          </p>
          <p className="mb-6 text-sm text-gray-500">
            {message || 'Driver already has an overlapping trip that day.'}
          </p>
          <div className="flex justify-end">
            <button onClick={onClose} className="px-6 py-2 bg-purple-500 text-white rounded-lg hover:bg-purple-600">
              OK
            </button>
          </div>
        </div>
      </div>
    </>,
    document.body,
  );
};

export default OverlapBlockedModal;
